// ProfileCard.js
import React from "react";
import GoogleHotels from "./GoogleHotels";
import Tripadvisor from "./Tripadvisor";
import HolidayCheck from "./HolidayCheck";
import WebSite from "./WebSite";
import DigitalCard from "./DigitalCard";
import QRev from "./QRev";
import Share from "./Share";
import "./ProfileCard.css";

const ProfileCard = () => {
  return (
    <div className="container">
      <div className="card-container">
        <div className="image">
          <img src="/images/profile-image.jpg" alt="Logo Hotel Condesa" />
        </div>
        <div className="descripcion">
          <h2>QR Share</h2>
          <br />
          <div className="buttons">
            <GoogleHotels />
            <Tripadvisor />
            <HolidayCheck />
            <WebSite />
            <DigitalCard />
            <QRev />
            <br />
            <Share />
            {/* Footer de marca */}
            <footer className="footer">
              <p
                style={{
                  fontSize: "0.75rem",
                  color: "#999",
                  textAlign: "center",
                  marginTop: "0rem",
                }}
              >
                Powered by <strong>QR Share</strong> ·{" "}
                <a
                  href="https://qrshare.app"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#999" }}
                >
                  qrshare.app
                </a>
              </p>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
